import { render, staticRenderFns } from "./GeneralTab.htm?vue&type=template&id=05bbc754&scoped=true&"
import script from "./GeneralTab.ts?vue&type=script&lang=js&"
export * from "./GeneralTab.ts?vue&type=script&lang=js&"
import style0 from "./GeneralTab.scss?vue&type=style&index=0&id=05bbc754&lang=scss&scoped=true&"
import style1 from "./GeneralTabSection.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbc754",
  null
  
)

export default component.exports